import React from 'react';
import { Divider as AntdDivider, type DividerProps } from 'antd';
import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';
import { typeStyle } from 'constants/typography';

interface Props {
  titleId?: string;
  margin?: string;
  titleValues?: Record<string, any>;
  color?: string;
  type?: DividerProps['type'];
  orientation?: DividerProps['orientation'];
  orientationMargin?: string;
  title?: React.ReactNode;
  className?: string;
}

const Divider: React.FC<Props> = ({
  titleId,
  titleValues,
  margin,
  color,
  type = 'horizontal',
  orientation = 'left',
  orientationMargin = '2%',
  title,
  className
}) => {
  // antd gives any truthy children its with-text treatment, an empty array included, which gaps the rule
  // around an empty label. A rule with no title passes none, so it draws exactly like antd's own.
  const hasTitle = Boolean(titleId || title);
  const ruleMargin = margin ?? (type === 'vertical' ? undefined : '5px 0px');

  return (
    <StyledDivider
      className={className}
      type={type}
      style={ruleMargin === undefined ? undefined : { margin: ruleMargin }}
      color={color}
      orientation={orientation}
      orientationMargin={hasTitle ? orientationMargin : undefined}>
      {hasTitle && (
        <>
          {titleId && <FormattedMessage id={titleId} values={titleValues} />}
          {title}
        </>
      )}
    </StyledDivider>
  );
};

const StyledDivider = styled(AntdDivider)<{ color?: string }>`
  .ant-divider-inner-text {
    ${typeStyle.labelMd}
    color: var(--text-disabled);
  }
`;

export default Divider;
